import { BookService } from '../../services/BookService';
import { AppThunk } from '../store';
import { libraryActions } from './librarySlice';

export const booksLoadAction = (): AppThunk => async dispatch => {
  const books = await BookService.getBooks();
  dispatch(libraryActions.acceptBooks(books));
};
